import { useEffect, useState } from "react";
import { useDebounce } from "../../hooks/useDebounce";
import { useProductBrowserState } from "../../hooks/useProductBrowserState";
import { useTranslate } from "../../hooks/useTranslate/useTranslate";
import { Slider } from "../ui/slider";

// export type ItemWidthSliderProps = {
// 	//catalogid: string | undefined;
// };
export const ItemWidthSlider: React.FC /*<ItemWidthSliderProps>*/ = () => {
	const SLIDER_MIN = 185;
	const SLIDER_MAX = Math.min(window.innerWidth - 6 * 16, 512);
	const productBrowserState = useProductBrowserState();
	const debounceItemWidth = useDebounce<number>({
		callback: (value: number) => {
			productBrowserState.setItemWidth(value);
		},
		delay: 250,
		immediate: false,
	});
	const itemWidth = productBrowserState.get().itemWidth;
	const [sliderValue, setSliderValue] = useState(itemWidth);
	//console.log(productBrowserState.get().itemWidth, sliderValue);
	const translateProductBrowser = useTranslate();

	useEffect(() => {
		setSliderValue(itemWidth);
	}, [itemWidth]);

	return (
		<div
			className="mx-4 w-[90px]"
			title={`${translateProductBrowser("Thumbnail Size")}: ${sliderValue}`}
		>
			<Slider
				className="[&_[data-slot=slider-range]]:bg-primary [&_[data-slot=slider-thumb]]:border-primary [&_[data-slot=slider-thumb]]:bg-primary [&_[data-slot=slider-track]]:bg-border"
				value={[sliderValue]}
				onValueChange={(value) => {
					const nextValue =
						typeof value === "number" ? value : (value[0] ?? SLIDER_MIN);
					setSliderValue(nextValue);
					debounceItemWidth(nextValue);
				}}
				min={SLIDER_MIN}
				max={SLIDER_MAX}
			/>
		</div>
	);
};
